import { Test } from '@/models/Test'

const ourTest = (response) => {
  return new Test({
    'id': response.id,
    'name': response.name,
    'start': new Date(response.startDate || response.startTest),
    'end': new Date(response.endDate || response.endTest),
    'countryId': response.country,
    'breakout': response.destination,
    'percentage': response.percentage,
    'status': response.status,
    'sendNotification': response.sendNotification,
    'carrierId': response.providerId,
    'result': response.result
  })
}

const theirTest = (test) => {
  return {
    'id': test.id,
    'name': test.name,
    'startTest': test.start.toString(),
    'endTest': test.end.toString(),
    'country': test.countryId,
    'destination': test.breakout,
    'percentage': test.percentage,
    'status': test.status,
    'sendNotification': test.sendNotification,
    'providerId': test.carrierId
  }
}

export {
  ourTest,
  theirTest
}



// WEBPACK FOOTER //
// ./src/api/routing/translator.js